import { render, staticRenderFns } from "./InstallmentInfo.vue?vue&type=template&id=4c0963c7&"
import script from "./InstallmentInfo.vue?vue&type=script&lang=js&"
export * from "./InstallmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports